////////LIBRARY/////////
import axios from 'axios'

export function API_TOKEN(token) {
	return axios.create({
		baseURL: '/extranetv2_admin',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
	})
}
export function API_TOKEN_DL_FILE(token) {
	return axios.create({
		baseURL: '/extranetv2_admin',
		responseType: 'blob',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	})
}

export const API = axios.create({
	baseURL: '/extranetv2_admin',
})

export default API_TOKEN
